module.exports = __webpack_public_path__ + "img/logo_nlite.ddc1d199.png";